import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=0ca82e81&scoped=true"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"
import style0 from "./Benefit.vue?vue&type=style&index=0&id=0ca82e81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca82e81",
  null
  
)

export default component.exports